import React from 'react';
import { Countdown } from './Shared';
export const UrgencySection = () => {
  return <section id="precio-lanzamiento" className="bg-familia-bg border-t border-familia-cyan/30 py-10 md:py-16 px-4 md:px-6" data-id="element-238">
      <div className="max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-239">
        <h2 className="text-familia-red font-bold text-base sm:text-xl md:text-2xl mb-8 md:mb-12 animate-blink uppercase tracking-widest text-center" data-id="element-240">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <Countdown className="mb-8 md:mb-12" data-id="element-241" />

        <p className="text-familia-gray text-[15px] md:text-lg mb-8 md:mb-12 text-center" data-id="element-242">
          Después sube y no vuelve a bajar.
        </p>

        <div className="max-w-md mx-auto bg-familia-card border border-familia-cyan/25 p-4 md:p-6 rounded-2xl" data-id="element-243">
          <div className="flex justify-between items-center mb-4" data-id="element-244">
            <div className="flex items-center gap-2" data-id="element-245">
              <span className="w-2 h-2 bg-familia-red rounded-full animate-ping" data-id="element-246" />
              <span className="text-sm font-bold" data-id="element-247">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-familia-red font-bold text-sm" data-id="element-248">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-white/5 h-3 rounded-full overflow-hidden" data-id="element-249">
            <div className="bg-familia-cyan h-full w-[15%]" data-id="element-250" />
          </div>
        </div>
      </div>
    </section>;
};